import { useAccount } from "wagmi";
import useGlobalStore from "../../stores/global";
import { MemeCoreMainnet, MemeCoreTestnet } from "./constants"
import { MenuItem, Select, SelectChangeEvent } from "@mui/material";

const ChainSelect = () => {

  const options = [MemeCoreTestnet, MemeCoreMainnet]
  const initialChain = useGlobalStore((state) => state.initialChainId)
  const setInitialChain = useGlobalStore((state) => state.setInitialChainId)

  const account = useAccount()
  if (account.isConnected) {
    return null
  }

  const onSelect = (e: SelectChangeEvent) => {
    const selectedChainId = Number(e.target.value)
    setInitialChain(selectedChainId)
  }

  return (
    <Select onChange={onSelect} value={initialChain.toString()}>
      {options.map((chain) => (
        <MenuItem key={chain.id} value={chain.id}>
          {chain.name}
        </MenuItem>
      ))}
    </Select>
  )
}

export default ChainSelect